"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.levels = void 0;
exports.levels = ['silly', 'debug', 'verbose', 'info', 'warn', 'error'];
